import React from 'react'

export class ComponentDidMount extends React.Component<{
  onMount: () => void
  children?: React.ReactNode
}> {
  componentDidMount() {
    this.props.onMount()
  }

  render() {
    return this.props.children || <> </>
  }
}

export class ComponentWillUnmount extends React.Component<{
  onUnmount: () => void
  children?: React.ReactNode
}> {
  componentWillUnmount() {
    this.props.onUnmount()
  }

  render() {
    return this.props.children || <> </>
  }
}

export class ComponentDidUpdate extends React.Component<{
  onUpdate: () => void
  children?: React.ReactNode
}> {
  componentDidUpdate() {
    this.props.onUpdate()
  }

  render() {
    return this.props.children || <> </>
  }
}

export class ComponentDidUpdateWithPrevProps<A> extends React.Component<{
  onUpdate: (prevProps: A) => void
  children?: React.ReactNode
  value: A
}> {
  componentDidUpdate(prevProps: { value: A }) {
    this.props.onUpdate(prevProps.value)
  }

  render() {
    return this.props.children || <> </>
  }
}
